import { createElement } from 'react';
import ReactDOM from 'react-dom';
import './assets/style/index.scss';
import App from './App';

ReactDOM.render(createElement(App), document.getElementById('root'));
